import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import LGModalCrud from "../LGCrud/LGModalCrud";
import { useCompany } from "../../contexts/CompanyContext";
import ProductRequestForm from "./ProductRequestForm.tsx";
import { deleteProductRequest, getProductRequestList } from "../../api/productRequests/index.ts";
import dayjs from "dayjs";

const ProductRequestTable = () => {
  const { selectedCompany } = useCompany();

  const setStatusColor = (statusCode: string) => {
    switch (statusCode) {
      case "REQ_CREATED":
        return "warning";
      case "REQ_APPROVED":
        return "success";
      case "REQ_REJECTED":
        return "error";
      default:
        return "default";
    }
  };

  if (!selectedCompany) {
    return (
      <Box p={4}>
        <Typography>Seleccione una compañía primero</Typography>
      </Box>
    );
  }

  const productRequestCrudProps = {
    fetchFunction: getProductRequestList,
    deleteFunction: deleteProductRequest,
    data: { companyId: selectedCompany.id },
    columns: [
      {
        field: "product",
        headerName: "Producto",
        flex: 0.2,
        valueGetter: (value: any, row: any) => {
          return row.product ? `${row.product.code} - ${row.product.description || ""}` : "";
        },
      },
      {
        field: "quantity",
        headerName: "Cantidad",
        flex: 0.1,
        type: "number",
      },
      {
        field: "reservedDate",
        headerName: "Fecha de Reserva",
        flex: 0.15,
        valueFormatter: (value: any) => {
          if (!value) return "-";
          return dayjs(value).format("YYYY-MM-DD");
        },
      },
      {
        field: "reserveDuration",
        headerName: "Duración (días)",
        flex: 0.1,
        type: "number",
      },
      {
        field: "solicitor",
        headerName: "Solicitante",
        flex: 0.15,
      },
      {
        field: "status",
        headerName: "Estatus",
        flex: 0.15,
        renderCell: (params: any) => (
          <Box display="flex" justifyContent="center" alignItems="center">
            <Chip
              size="small"
              label={params.row.status?.name || "-"}
              color={setStatusColor(params.row.status?.code || "")}
            />
          </Box>
        ),
      },
      {
        field: "createdAt",
        headerName: "Fecha de Creación",
        flex: 0.15,
        valueFormatter: (value: any) => {
          if (!value) return "-";
          return dayjs(value).format("YYYY-MM-DD");
        },
      },
    ],
    addModalData: {
      header: "Nueva Solicitud de Producto",
      body: <ProductRequestForm onSubmit={() => {}} />,
    },
    editModalData: {
      header: "Editar Solicitud de Producto",
      body: <ProductRequestForm onSubmit={() => {}} />,
    },
    actions: ["create", "update", "delete"],
    customButtons: [],
  };

  return <LGModalCrud props={productRequestCrudProps} />;
};

export default ProductRequestTable;

